export default {
  multipleUpdateTitle: 'Aktualizacja wielu rekordów',
  title: 'Szczegóły',
  rules: {
    required: 'Pole jest wymagane',
    atLeast: 'Pole musi mieć przynajmniej',
    less: 'Pole musi mieć mniej niż',
    more: 'Pole musi mieć więcej niż',
    characters: 'znaków',
    emailMustBeValid: 'E-mail musi mieć poprawny format',
    passwordMustDiffer: 'Nowe hasło musi się różnić od poprzedniego',
    passwordMustBeSame: 'Hasła nie mogą się różnić',
  },
  alerts: {
    updated: 'Zaktualizowano',
    updateError: 'Błąd! Aktualizacja nie powiodła się',
    stored: 'Dodano',
    storeError: 'Błąd! Nie udało się dodać rekordu',
  },
  buttons: {
    create: 'Utwórz',
    modify: 'Modyfikuj',
    modifySelected: 'Modyfikuj wybrane rekordy',
    close: 'Zamknij',
  },
  files: {
    upload: 'Wgraj plik',
    show: 'Pokaż',
    download: 'Pobierz',
  },
}
